<template>
  {{ value }}
</template>
<script lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import moment from "moment";
import "moment-timezone";

export default {
  props: {
    timestamp: Number
  },
  setup(props: any) {
    const value = ref<string>();

    const calcValue = (): string => {
      const { timestamp } = props as {
        timestamp: number;
      };

      const diff = moment().unix() - timestamp;

      const hours = Math.floor(diff / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = Math.floor((diff % 3600) % 60);

      return `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${
        seconds < 10 ? "0" : ""
      }${seconds}`;
    };

    const timer = ref();

    onMounted(() => {
      value.value = calcValue();
      timer.value = setInterval(() => (value.value = calcValue()), 1000);
    });

    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value);
      }
    });

    return { value };
  }
};
</script>
